module.exports = __webpack_public_path__ + "static/media/08_CORTININHA_SEM_BOJO_ESTAMPADO_03.097d8eb8.jpg";